import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { interval, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { OnlineMeetingsService } from '../../services/online-meetings.service';

@Component({
  selector: 'app-online-meeting-lobby',
  templateUrl: './online-meeting-lobby.component.html',
  styleUrls: ['./online-meeting-lobby.component.scss']
})
export class OnlineMeetingLobbyComponent extends ComponentBase implements OnInit {

  constructor(private routingService: RoutingService
    , private route: ActivatedRoute
    , private onlineMeetingService: OnlineMeetingsService) {
    super();
  }

  source = interval(20000);
  eventOccurrenceId: number = 0;
  meetingId: number = 0;
  joinUrl: string;

  ngOnInit() {
    let sub = this.route.queryParams.pipe(
      switchMap(params => {
        if (+params["eventId"] != null) {
          this.eventOccurrenceId = +params["eventId"];
          return this.source;
        }
        else {
          return of(null);
        }
      }),
      switchMap(res => {
        if (this.eventOccurrenceId != 0) {
          return this.onlineMeetingService.getJoinUrlForEvent(this.eventOccurrenceId).pipe(
            catchError(err => {
              return of(null);
            })
          )
        }
        else {
          return of(null);
        }
      })
    ).subscribe(res => {
      if (res != null) {
        this.joinUrl = res['join_url'];
      }
    });
    this.addSubscription(sub);

  }

  onBack() {
    this.routingService.back();
  }

  onJoin() {
    if (this.joinUrl) {
      window.open(this.joinUrl, "_system")
    }
  }
}
